import {
  MapPin, FileText, Share2, ClipboardList, Tablet,
  Gauge, Route, Timer, ShieldCheck, Car,
} from "lucide-react";

export const CONTACT_EMAIL = "hello@driveassure.systems";
export const APK_URL = "#download"; // placeholder until APK is provided
export const APP_DOWNLOAD_URL = "https://driveassure.systems/download"; // QR deep-link to the app store
// Store listing URLs — placeholders until the listings go live. Update these two
// values to point the download badges at the real App Store / Google Play pages.
export const APP_STORE_URL = "#download"; // TODO: replace with live App Store listing URL
export const PLAY_STORE_URL = "#download"; // TODO: replace with live Google Play listing URL

// Founding Instructor scarcity counter (30 spots total).
export const FOUNDING_TOTAL = 30;
export const FOUNDING_TAKEN = 7;
export const FOUNDING_LEFT = FOUNDING_TOTAL - FOUNDING_TAKEN;

export const FEATURES = [
  {
    icon: MapPin,
    title: "GPS lesson tracking",
    desc: "Record the full route as the lesson runs and drop Identified Error pins on the exact intersection where each mistake happened.",
    tag: "Spatial",
    span: "lg:col-span-2",
  },
  {
    icon: Share2,
    title: "Shareable progress reports",
    desc: "Send learners and parents a clear, visual report of what to practise next.",
    tag: "For parents",
  },
  {
    icon: FileText,
    title: "Digital lesson records",
    desc: "Share with a parent or supervising driver directly from the app. Send a private summary of the learner's lesson instantly. The lesson summary and practice plan are best viewed in the app but work perfectly well via a browser. QR codes, links, and PDF versions can all be sent depending on the learner's, parent's, or supervisor's preferences.",
    tag: "Sharing & Archiving",
    span: "lg:col-span-3",
    featured: true,
    protection: {
      heading: "Your Record. Your Protection.",
      sub: "Every lesson summary is a timestamped, signed record of what was taught, where, and when. Should any accusation or investigation of a lesson ever arise, DriveAssure gives you the documentation you need.",
    },
  },
  {
    icon: ClipboardList,
    title: "Practice plans",
    desc: "Turn identified errors into structured, repeatable practice tasks between lessons.",
    tag: "Between lessons",
  },
  {
    icon: Tablet,
    title: "Supervisor tablet mode",
    desc: "A dedicated large-screen mode for supervising drivers and in-car assessments.",
    tag: "Pro & Founder",
    pro: true,
    span: "lg:col-span-2",
  },
];

export const STEPS = [
  {
    num: "01",
    title: "Start the drive",
    desc: "The app plots the route as the lesson begins. Telemetry logs speed, duration and vehicle data.",
    icon: Route,
  },
  {
    num: "02",
    title: "Drop the pin",
    desc: "Drop a pin at the exact time and place the learner makes an error. Every pin is anchored via GPS.",
    icon: MapPin,
  },
  {
    num: "03",
    title: "Identify the error",
    desc: "From the menu, choose an error from the icon board so the learner knows what they did wrong — and where they did it.",
    icon: ClipboardList,
  },
];

export const PROBLEM_POINTS = [
  { icon: MapPin, text: "Pins the exact intersection where an error happened" },
  { icon: ShieldCheck, text: "Captures the traffic rule breached, automatically" },
  { icon: Timer, text: "Turns a 60-minute lesson into a 60-second recap" },
];

export const TIERS = [
  {
    name: "Free",
    price: "Free",
    cadence: "",
    audience: "For learners, supervising drivers & parents",
    features: [
      "Free to download — anyone can register",
      "Full functionality, limited to 5 lessons / month",
      "Export to family (PDF only)",
      "Links to your instructor via Family Link code & QR",
    ],
    cta: "Get the app",
    variant: "free",
  },
  {
    name: "Founding Instructor",
    monthly: { price: "A$30", cadence: "/month" },
    yearly: { price: "A$300", cadence: "/year", note: "2 months free" },
    audience: "Only 30 founding spots — price locked for life",
    features: [
      "Price locked for life",
      "Everything in Instructor",
      "Supervisor Tablet Mode",
      "Founding Member badge",
    ],
    cta: "Join the Founder Program",
    variant: "featured",
    badge: "Only 30 spots",
    lookup: { monthly: "founding_monthly", yearly: "founding_yearly" },
  },
  {
    name: "DriveAssure Instructor",
    monthly: { price: "A$30", cadence: "/month" },
    yearly: { price: "A$300", cadence: "/year", note: "2 months free" },
    audience: "The full professional toolkit",
    features: ["Unlimited lessons", "Digital records & PDF export", "Shareable progress reports", "Practice plans"],
    cta: "Get started",
    variant: "standard",
    lookup: { monthly: "instructor_monthly", yearly: "instructor_yearly" },
  },
  {
    name: "DriveAssure Pro",
    monthly: { price: "A$45", cadence: "/month" },
    yearly: { price: "A$450", cadence: "/year", note: "2 months free" },
    audience: "For growing driving schools",
    features: [
      "Everything in Instructor",
      "Supervisor Tablet Mode",
      "Priority support",
      "Early access to new tools",
      "Linked dashcam integration — coming in 2027",
    ],
    cta: "Go Pro",
    variant: "pro",
    lookup: { monthly: "pro_monthly", yearly: "pro_yearly" },
  },
];

export const TRUST_ICONS = [Car, Gauge, MapPin, ShieldCheck];
